const MAX_LENGTH = 255;

export const useInlineEditing = (controller, options = {}) => {
  const controllerEdit = controller.edit?.bind(controller);
  const controllerSave = controller.save?.bind(controller);
  const controllerCancel = controller.cancel?.bind(controller);
  const currentData = {};
  const handlers = {};

  function truncateContent(target) {
    if (target.textContent.length > MAX_LENGTH) {
      const selection = window.getSelection();
      const cursorOffset = Math.min(
        selection.focusOffset,
        MAX_LENGTH
      );

      target.textContent = target.textContent.slice(0, MAX_LENGTH);

      // Restore cursor position
      if (target.firstChild) {
        const range = document.createRange();
        range.setStart(target.firstChild, cursorOffset);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  }

  function edit(...args) {
    options.targets.forEach((targetName) => {
      const target = controller.targets.findTarget(targetName);
      currentData[targetName] = target.textContent;
      target.contentEditable = true;

      // Create stable handler references for proper cleanup
      const keyHandler = (evt) => {
        if (evt.code === "Enter") {
          target.blur();
          evt.preventDefault();
          evt.stopPropagation();
        }
      };
      const inputHandler = () => truncateContent(target);

      handlers[targetName] = { keyHandler, inputHandler };
      target.addEventListener("keydown", keyHandler);
      target.addEventListener("input", inputHandler);
    });

    if (controllerEdit) return controllerEdit(...args);
  }

  function removeHandlers() {
    options.targets.forEach((targetName) => {
      const target = controller.targets.findTarget(targetName);
      const h = handlers[targetName];
      if (h) {
        target.removeEventListener("keydown", h.keyHandler);
        target.removeEventListener("input", h.inputHandler);
      }
      target.contentEditable = false;
    });
  }

  function cancel(...args) {
    options.targets.forEach((targetName) => {
      const target = controller.targets.findTarget(targetName);
      target.textContent = currentData[targetName];
    });
    removeHandlers();

    if (controllerCancel) return controllerCancel(...args);
  }

  function save(...args) {
    removeHandlers();

    if (controllerSave) return controllerSave(...args);
  }

  Object.assign(controller, { save, edit, cancel });
};
